const PATH = 'i18n';

const CLASS_NAME = 'kicl--views--workshop--i18n';

export { CLASS_NAME, PATH };
